import React from 'react'

const Pencil = ({ color = '#DC7B19', height = '28', width = '28' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 14 14`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.82617 11.7987H3.90359L10.0306 5.67167L7.95316 3.59426L1.82617 9.72124V11.7987ZM2.93413 10.181L7.95316 5.16201L8.46282 5.67167L3.44379 10.6907H2.93413V10.181Z"
        stroke={color}
      />
      <path
        d="M10.3408 1.98772C10.1248 1.77167 9.77574 1.77167 9.55969 1.98772L8.54592 3.0015L10.6233 5.07891L11.6371 4.06514C11.8532 3.84909 11.8532 3.50008 11.6371 3.28403L10.3408 1.98772Z"
        stroke={color}
      />
    </svg>
  )
}

export default Pencil
